import { SET_HOME_ACTIVE } from ":mutations";

const state = {
  active: "hero"
};

const mutations = {
  [SET_HOME_ACTIVE](state, { active }) {
    state.active = active;
  }
};

const actions = {};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
